import * as React from 'react';
import { AspectRatio } from 'react-aspect-ratio';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box, IconButton } from '@mui/material';

import PlayIcon from '../../../components/PlayIcon/PlayIcon';
import { VenueReservationContentItemV2 } from '../../../graphql/API';

type Props = {
  items: VenueReservationContentItemV2[];
  onItemClick: (item: VenueReservationContentItemV2) => void;
};

const arrowSx = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  color: '#111',
  zIndex: 2,
  '&:hover': { backgroundColor: '#fff' },
};

const ReservationContentCarousel: React.FC<Props> = ({ items, onItemClick }) => {
  const [index, setIndex] = React.useState(0);

  const safeIndex = Math.min(index, items.length - 1);
  const current = items[safeIndex];
  const hasMultiple = items.length > 1;

  const goPrev = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIndex((i) => (i - 1 + items.length) % items.length);
  };

  const goNext = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIndex((i) => (i + 1) % items.length);
  };

  if (!current) {
    return null;
  }

  return (
    <Box>
      <Box
        sx={{ position: 'relative', cursor: 'pointer', borderRadius: '11px', overflow: 'hidden' }}
        onClick={() => onItemClick(current)}
      >
        <AspectRatio ratio="0.8">
          <Box
            component='img'
            src={current.images?.medium ?? ''}
            alt=''
            sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </AspectRatio>

        {current.images?.video && <PlayIcon />}

        {hasMultiple && (
          <>
            <IconButton size='small' onClick={goPrev} sx={{ ...arrowSx, left: 8 }}>
              <ArrowBackIosNewIcon sx={{ fontSize: 16 }} />
            </IconButton>
            <IconButton size='small' onClick={goNext} sx={{ ...arrowSx, right: 8 }}>
              <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </>
        )}
      </Box>

      {hasMultiple && (
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mt: 2 }}>
          {items.map((item, i) => (
            <Box
              key={item.id ?? i}
              onClick={() => setIndex(i)}
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                cursor: 'pointer',
                backgroundColor: i === safeIndex ? '#111' : '#D9D9D9',
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default ReservationContentCarousel;
